import Helpers from '../Helpers'

class ResultsUI {
    constructor(showMoreEvent, extendEvent) {
        this.showmore = document.getElementsByClassName('results-list__loading')[0]
        this.specialOfferExtender = document.getElementsByClassName('results-list__extend--offers')[0]
        this.contact = document.getElementsByClassName('results-list__extend--contact')[0]
        this.breadcrumbs = document.getElementById('breadcrumb')
        this.resultsTitle = document.getElementById('searchTitle')
        this.resultsFilterButtonMobile = document.getElementsByClassName('results-aside__apply-filter')[0]
        this.resultsCountTitleMobile = document.getElementsByClassName('results-mobile-nav__title')[0]
        this.warning = document.getElementsByClassName('results-list__warning')[0]
        this.range = document.getElementsByClassName('results-list__range')[0]
        this.readMore = document.getElementsByClassName('read-more')[0]
        this.readMoreText = document.getElementsByClassName('results-end__text')[0]
        this.backToTop = document.getElementsByClassName('back-to-top')[0]
        this.results = document.getElementById('search-results')
        this.showMoreEvent = showMoreEvent
        this.extendEvent = extendEvent
        this.listeners()        
    }

    listeners() {
        new Helpers(this.specialOfferExtender.getElementsByTagName('button')).eventListener((e) => {
            this.extendEvent({ oso: null })
        });
        new Helpers(this.range).eventListener((e) => {
            this.extendEvent({ nlm: parseInt(e.currentTarget.getAttribute('data-range')) })
        })

        new Helpers(this.showmore).eventListener((e) => {
            e.preventDefault();
            this.showMoreEvent();
        })
        //new Helpers(this.readMore).eventListener((e) => {
        //    e.preventDefault();
        //    this.readMoreText.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //    window.dataLayerQueue.push({ event: 'readMoreClick' })
        //})
        new Helpers(this.backToTop).eventListener((e) => {
            e.preventDefault();
            this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
            window.dataLayerQueue.push({ event: 'backToTopClick'})

        })
        
    }

    updateUI(params) {
        this.toggleShowMore(params.pMax < params.totalPages && params.pMax > 0)
        this.toggleContact(params.totalCount == 0)
        this.setResultsTitle(params.title)
        this.setCountTitle(params)
        this.setExtenders(params)
        this.setWarning(params.warning)
        this.setRange(params)
    }

    loading() {
        this.setWarning('')
        this.contact.setAttribute('aria-hidden', 'true')
        this.specialOfferExtender.setAttribute('aria-hidden', 'true')
    }

    resetPosition() {
        window.scroll(0, document.getElementsByClassName('results-output')[0].offsetTop)
    }

    toggleShowMore(visible) {
        this.showmore.setAttribute('aria-hidden', visible ? 'false' : 'true')
    }

    toggleContact(visible) {
        this.contact.setAttribute('aria-hidden', visible ? 'false' : 'true')
    }

    setResultsTitle(text) {
        this.resultsTitle.innerText = text;
    }

    setCountTitle(params) {
        this.resultsFilterButtonMobile.getElementsByTagName('span')[0].innerHTML = `${params.totalCount} cottage${params.totalCount !== 1 ? 's' : ''}`
        this.resultsCountTitleMobile.getElementsByTagName('span')[0].innerHTML = `${params.totalCount} cottage${params.totalCount !== 1 ? 's' : ''}`
    }

    setExtenders(params) {
        this.specialOfferExtender.setAttribute('aria-hidden', true)
        if (params.oso === 'Y') {
            if ((params.pMax === params.totalPages || params.pMax === 0 || params.totalPages === 0) && params.totalWithoutOfferFilter > 0) {
                const offerExtenderIntro = `We've got ${params.totalWithoutOfferFilter} more holiday cottage${params.totalWithoutOfferFilter !== 1 ? 's' : ''} in ${params.regionName} that match your search.`
                this.specialOfferExtender.getElementsByTagName('p')[0].innerText = offerExtenderIntro
                this.specialOfferExtender.setAttribute('aria-hidden', false)
            }
        }
    }

    setWarning(warningMessage) {
        if (warningMessage != undefined && warningMessage.length > 0) {
            this.warning.getElementsByTagName('p')[0].innerText = warningMessage
            this.warning.setAttribute('aria-hidden', 'false')
        } else {
            this.warning.getElementsByTagName('p')[0].innerText = ''
            this.warning.setAttribute('aria-hidden', 'true')
        }
    }

    setRange(params) {
        let range = 0
        // calculate extended range value
        if (params.nlc && params.nlm < 30) {
            if (params.nlm >= 20) {
                range = 30
            } else if (params.nlm >= 10) {
                range = 20
            } else if (params.nlm >= 5) {
                range = 10
            } else if (params.nlm >= 1) {
                range = 5
            } else if (params.nlm == 0) {
                range = 1
            }
        }
        this.range.setAttribute('data-range', range)
        // toggle visiblity
        this.range.setAttribute('aria-hidden', range > 0 && (params.pMax === 0 || params.pMax >= params.totalPages) ? 'false' : 'true')

        this.range.getElementsByTagName('span')[0].innerText = `${range} mile${range !== 1 ? 's' : ''}`
        this.range.getElementsByTagName('span')[1].innerText = params.locationName

    }

    setBreadcrumbs(xmlData) {

        let deleteEl = false
        const crumbEls = Array.from(this.breadcrumbs.getElementsByTagName('li'))
        // ignore the first el (home link)
        crumbEls.shift()
        // delete the rest
        crumbEls.forEach(crumb => crumb.parentNode.removeChild(crumb))

        // loop thru the xml elements and add each as a crumb
        Array.from(xmlData.getElementsByTagName('breadcrumb')).forEach(data => {
            const newCrumb = document.createElement('li');
            const link = document.createElement('a');
            const url = new URL(data.getAttribute('href'), window.location.origin);
            link.href = url.pathname + url.search;
            link.innerText = data.getAttribute('text');
            newCrumb.appendChild(link);
            this.breadcrumbs.getElementsByTagName('ul')[0].appendChild(newCrumb);
        })
    }

    //toggle show more status
    showMoreLoading(loading) {
        this.showmore.setAttribute('data-enabled', loading ? 'false' : 'true')

    }

}

export default ResultsUI